module.exports = __webpack_public_path__ + "static/media/GroupAdd.67edea73.svg";